export const SET_ORIGIN = "SET_ORIGIN"

export const SET_HOSTNAME = "SET_HOSTNAME"
